/* eslint-disable */
import api, { BASE_URL } from "../api";

const state = {
  loading: false,
  settings: {},
  paymentProcessor: {}
};

// getters
const getters = {
  uses_merchants: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.merchants
      : false;
  },
  uses_post_purchase_content: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.post_purchase_content
      : false;
  },
  uses_customizations: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.customizations
      : false;
  },
  uses_coming_soon: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.coming_soon
      : false;
  },
  uses_limited_release: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.limited_release
      : false;
  },
  uses_collections: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.uses_collections
      : false;
  },
  uses_pickup: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.uses_pickup
      : false;
  },
  uses_delivery: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.uses_delivery
      : false;
  },
  uses_shipping: state => {
    return !!state.settings.shop_config
      ? state.settings.shop_config.uses_shipping
      : false;
  }
};

// actions
const actions = {
  initSettings: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(`${BASE_URL}/shop/admin/settings/`)
      .then(response => {
        context.commit("SET_SETTINGS", response.data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  updateSettings: (context, newSettings) => {
    context.commit("SET_LOADING", true);
    return api(context)
      .patch(
        `${BASE_URL}/shop/admin/settings/${context.state.settings.id}/`,
        newSettings
      )
      .then(response => response.data)
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  initPaymentProcessor: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(`${BASE_URL}/shop/admin/payment-processor/`)
      .then(response => {
        context.commit("SET_PAYMENT_PROCESSOR", response.data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  getStripeDashboardLink: context => {
    context.commit("SET_LOADING", true);
    return api(context)
      .get(
        `${BASE_URL}/shop/admin/stripe-dashboard/${context.state.settings.id}/`
      )
      .then(response => response.data)
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  }
};

// mutations
const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
  SET_PAYMENT_PROCESSOR(state, paymentProcessor) {
    state.paymentProcessor = paymentProcessor;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
